var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"afs"},[_c('h2',[_vm._v("客维甄选")]),_c('img',{attrs:{"src":require("../assets/afs.png")}}),_c('div',{staticClass:"content"},[_c('p',[_vm._v("截图后使用微信扫一扫")]),_c('p',[_vm._v("添加售后联系客服")]),_c('p',[_vm._v("客维智能科技(广州)有限公司；")]),_c('p',[_vm._v("咨询热线及服务时间：4000778183(周一至周五9:00-18:00)")])])])
}]

export { render, staticRenderFns }